import { stringDuckCreator } from '@atc/modular-redux';

export default stringDuckCreator({
    store: 'ATC_ID',
    initialState: null,
});
